import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DefaultTabsBorderedBottom from './component/DefaultTabsBorderedBottom';

const Booking = () => (
  <div>
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
      marginBottom: '5px',
    }}
    >
      <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
      <Typography sx={{ color: 'text.primary' }}>Booking</Typography>
      {/* <Typography sx={{ color: 'text.primary' }}>Rejected Request</Typography> */}
    </Breadcrumbs>
    <DefaultTabsBorderedBottom />
  </div>
  );

export default Booking;
